import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Signup() {
  const [user, setUser] = useState({ username: '', password: '' });
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Hotel Atlanta | Signup";
  }, []);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.id]: e.target.value });
  };

  const handleSignup = (e) => {
    e.preventDefault();
    const users = JSON.parse(localStorage.getItem('users')) || [];
    const exists = users.find(u => u.username === user.username);
    if (exists) {
      alert("User already exists.");
      return;
    }
    users.push(user);
    localStorage.setItem('users', JSON.stringify(users));
    alert("Signup successful!");
    navigate('/login');
  };

  return (
    <section id="contact-form" className="py-3" style={{ minHeight: 'calc(100vh - 140px)' }}>
      <div className="container">
        <h1 className="l-heading"><span className="text-primary">New</span> User Signup</h1>
        <form onSubmit={handleSignup}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input type="text" id="username" required onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" required onChange={handleChange} />
          </div>
          <button type="submit" className="btn">Signup</button>
        </form>
      </div>
    </section>
  );
}

export default Signup;